import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import { Checkbox, Group, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class AddMultipleDocumentsCofirmationModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE
  };
  
  constructor(props) {
    super(props);
  }
  
  render() {
    const { open, toggle, className, numberOfFiles, next } = this.props;
    
    return (
      <CustomModal
        heading={'Dokumente zusammenfügen'}
        headingClassName={'add-multiple-files-confirmation-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
      >
        <Stack>
            <Group>
              <span style={{fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Sie haben {numberOfFiles} Dokumente ausgewählt. hellohousing fügt diese in ein PDF-Dokument zusammen.</span>
              <span style={{fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Wenn Sie für jedes Dokument einen einzelnen Beleg erzeugen wollen, wählen Sie bitte in der Belegübersicht die Funktion Sammel-Upload aus.</span>
            </Group>
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Abbrechen'}
                    className='gray-btn'
                    onClick={()=> toggle()}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Fortfahren'}
                    className='purple-btn'
                    onClick={()=> next()}
                    />
                </div>
            </Group>
        </Stack>
      </CustomModal>
    );
  }
}

export default AddMultipleDocumentsCofirmationModal;
